import { render, staticRenderFns } from "./applyLecturer.vue?vue&type=template&id=bbf6471c"
import script from "./applyLecturer.vue?vue&type=script&lang=js"
export * from "./applyLecturer.vue?vue&type=script&lang=js"
import style0 from "./applyLecturer.vue?vue&type=style&index=0&id=bbf6471c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports